import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Chapter } from "./Chapter";

const ease = [0.22, 1, 0.36, 1];

export const Stats = () => {
  const { t } = useLang();
  return (
  <section id="scale" data-testid="stats-section" className="py-24 md:py-32 px-6 lg:px-10 max-w-7xl mx-auto">
    <Chapter number="03" overline={t.chapters.scale.overline} title={t.chapters.scale.title} />

    <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
      {t.stats.map((s, i) => (
        <motion.div
          key={s.label}
          data-testid={`stat-card-${i}`}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: (i % 4) * 0.08, ease }}
          className={`${s.span} ${
            s.volt ? "bg-volt text-ink" : "bg-graphite border border-line text-paper"
          } p-8 md:p-10 flex flex-col justify-between min-h-[160px] ${s.big ? "md:min-h-[360px]" : ""} group hover:-translate-y-1 transition-transform duration-500`}
        >
          <span className={`font-mono font-bold tracking-tight ${s.big ? "text-6xl md:text-8xl" : "text-4xl md:text-5xl"} ${s.volt ? "text-ink" : "text-paper group-hover:text-volt"} transition-colors`}>
            {s.value}
          </span>
          <p className={`font-body text-sm mt-6 leading-snug ${s.volt ? "text-ink/80 font-medium" : "text-dim"}`}>
            {s.label}
          </p>
        </motion.div>
      ))}
    </div>
  </section>
  );
};
